/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const arrow_down_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.5 14.625 7.5 7.5m0 0 7.5-7.5m-7.5 7.5V1.875"
    />
  </svg>
)
export default arrow_down_medium
